import { Colors, Services } from '@sigma-frontend-libs/commons'

import { components, icons, sizes } from '@/utils'

import buttonConfirm from '@/components/button/confirm'
import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'

function renderHeaderContent(h, options) {
  const { path, serviceName } = options

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            icon: icons.integration_instructions,
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}`)
    ]
  )
}
function renderHeader(h, options, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderHeaderContent.call(this, h, options),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderField(h, options, field) {
  const { path, serviceName, defaults } = options
  const key = [ path, field ].filter(Boolean).join('.')
  const defaultValue = defaults?.[key]
  const commonProps = {
    value: this.proxy[field],
    defaultValue,
    label: this.getTranslate(`${serviceName}.labels.${key}`),
    dense: true,
    clearable: true,
    details: false
  }
  const on = {
    input: event => {
      this.proxy[field] = event
    }
  }

  if (field === 'widgetId') {
    return h(
      components.select,
      {
        props: {
          ...commonProps,
          service: Services['otp-settings/widgets'],
          picks: [ 'id', 'name', 'isActive', 'isBlocked' ],
          itemTitle: 'name',
          autocomplete: true
        },
        scopedSlots: {
          item: ({ item }) => {
            let isBlockedColor
            if (item.isBlocked) {
              isBlockedColor = Colors.error
            } else {
              isBlockedColor = Colors.success
            }

            let isActiveColor
            if (item.isActive) {
              isActiveColor = Colors.success
            } else {
              isActiveColor = Colors.error
            }

            return h(
              'div',
              {
                class: 'faic fjcsb grid-gap--8'
              },
              [
                h(
                  textOverflow,
                  {
                    props: {
                      value: item.name
                    }
                  }
                ),
                h(
                  'div',
                  {
                    class: 'faic grid-gap--4'
                  },
                  [
                    h(
                      tag,
                      {
                        props: {
                          label: this.getTranslate(`booleans.isBlocked.${item.isBlocked}`),
                          color: isBlockedColor,
                          size: sizes.small
                        }
                      }
                    ),
                    h(
                      tag,
                      {
                        props: {
                          label: this.getTranslate(`booleans.isActive.${item.isActive}`),
                          color: isActiveColor,
                          size: sizes.small
                        }
                      }
                    )
                  ]
                )
              ]
            )
          }
        },
        on
      }
    )
  }

  return h(
    components['text-field'],
    {
      props: commonProps,
      on
    }
  )
}
function renderItem(h, options, field) {
  const { path, defaults } = options
  const key = [ path, field ].filter(Boolean).join('.')
  const defaultValue = defaults?.[key]

  return h(
    buttonConfirm,
    {
      props: {
        value: this.proxy[field],
        loading: this.getLoading(field),
        disabled: this.getDisabled(field)
      },
      on: {
        input: () => {
          const value = this.proxy[field] ?? defaultValue

          this.submitField(field, value)
          this.$emit('input', value, key)
        }
      }
    },
    [ renderField.call(this, h, options, field) ]
  )
}
function renderItems(h, options) {
  return this.fields.map(field => {
    return renderItem.call(this, h, options, field)
  })
}
function renderBody(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--12 pa-2'
    },
    [ renderItems.call(this, h, options) ]
  )
}

export default function(h, options) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, options, expanded)
        },
        default: () => {
          return renderBody.call(this, h, options)
        }
      }
    }
  )
}
